/**
 * HL: expand/collapse sidebar filter groups from the full heading, not just +/-.
 * OOTS Parallax only binds `.toggle span`; supplements use toggle-all--true on desktop.
 */
(function ($) {
  'use strict';

  if (!$) return;

  function allowsToggle($heading) {
    if ($heading.closest('.hl-sidebar-filters').length) return true;
    var $sidebar = $heading.closest('.sidebar');
    return (
      (window.PXUTheme &&
        window.PXUTheme.media_queries &&
        window.PXUTheme.media_queries.medium.matches) ||
      $sidebar.hasClass('toggle-all--true')
    );
  }

  function setPanelOpen($panel, open) {
    if (!$panel || !$panel.length) return;
    $panel.css('display', open ? 'block' : 'none');
  }

  function toggleBlock($heading) {
    var $span = $heading.children('span').first();
    var $panel = $heading.next('ul');
    if (!$span.length || !$panel.length) return;

    var open = $panel.css('display') === 'none' || !$panel.is(':visible');
    setPanelOpen($panel, open);
    $span.html(open ? '\u2212' : '+');
    $span.attr('aria-expanded', open);
    $heading.attr('aria-expanded', open ? 'true' : 'false');
  }

  function onHeadingActivate(e, $heading) {
    if (!allowsToggle($heading)) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    toggleBlock($heading);
  }

  document.addEventListener(
    'click',
    function (e) {
      var heading = e.target.closest('.hl-sidebar-filters .sidebar__block-heading.toggle');
      if (!heading) return;
      onHeadingActivate(e, $(heading));
    },
    true
  );

  document.addEventListener(
    'touchend',
    function (e) {
      var heading = e.target.closest('.hl-sidebar-filters .sidebar__block-heading.toggle');
      if (!heading) return;
      onHeadingActivate(e, $(heading));
    },
    true
  );

  $(document).on('keyup', '.hl-sidebar-filters .sidebar__block-heading.toggle', function (e) {
    if (!$('body').hasClass('user-is-tabbing')) return;
    if (e.key !== 'Enter' && e.key !== ' ') return;
    onHeadingActivate(e, $(this));
  });

  // Desktop sidebar headings outside hl-sidebar-filters container (legacy blocks).
  $(document).on('click', '.sidebar h4.toggle', function (e) {
    if ($(this).closest('.hl-sidebar-filters').length) return;
    onHeadingActivate(e, $(this));
  });

  document.addEventListener(
    'click',
    function (e) {
      var link = e.target.closest('[data-hl-brand-filter] a[data-filter-input]');
      if (!link || link.hasAttribute('data-disabled')) return;
      if (document.querySelector('.hl-supplements-collection[data-hl-filter-ajax]')) return;
      if (document.querySelector('.hl-supplements-collection[data-hl-search-filter-ajax]')) return;

      var url = link.dataset.url || link.getAttribute('href');
      if (!url) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      var checkbox = link.querySelector('[data-filter-checkbox]');
      if (checkbox) checkbox.toggleAttribute('data-filter-checked');

      window.location.assign(url);
    },
    true
  );

  function hlSyncMobileFilterGroups() {
    var root = document.querySelector('.faceted-filter-modal .hl-sidebar-filters');
    if (!root) return;

    root.querySelectorAll('[data-filter-group]').forEach(function (group) {
      var heading = group.querySelector('.sidebar__block-heading.toggle');
      var panel = group.querySelector('[data-filter-group-list], ul.toggle_list');
      var toggle = heading && heading.querySelector('span');
      if (!heading || !panel || !toggle) return;

      var hasActive =
        group.querySelector('[data-filter-active]') ||
        group.querySelector(
          '.faceted-filters__filter-link--active:not(.hl-filter-all-brands .faceted-filters__filter-link--active)'
        );
      var open = !!hasActive;

      panel.style.display = open ? 'block' : 'none';
      toggle.textContent = open ? '\u2212' : '+';
      heading.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  $(document).on('click', '[data-filter-modal-open], [data-hl-filter-dropdown-toggle]', function () {
    window.setTimeout(function () {
      hlSyncMobileFilterGroups();
      if (window.hlSyncSupplementsFilterUi) window.hlSyncSupplementsFilterUi(window.location.search);
      if (window.hlSyncSearchFilterUi) window.hlSyncSearchFilterUi();
    }, 150);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-hl-open-chatbot]');
    if (!btn) return;
    e.preventDefault();
    if ($ && $.fancybox && $.fancybox.getInstance()) {
      $.fancybox.close();
    }
    if (typeof window.hlOpenChatbot === 'function') {
      window.hlOpenChatbot();
      return;
    }
    var toggle = document.getElementById('chatToggle');
    if (toggle) toggle.click();
  });
})(window.jQuery);
